// utils/messageFormatter.js

/**
 * Formats message content with markdown-like styling
 * @param {string} content - The raw message content
 * @returns {object} Formatted content as dangerouslySetInnerHTML object
 */
export const formatMessage = (content) => {
    // Simple markdown-like formatting
    // Convert code blocks with language
    let formattedContent = content.replace(
      /```(\w*)\n([\s\S]*?)```/g, 
      '<pre class="code-block"><div class="code-header">$1</div><code>$2</code></pre>'
    );
    
    // Convert code blocks without language
    formattedContent = formattedContent.replace(
      /```([\s\S]*?)```/g, 
      '<pre class="code-block"><code>$1</code></pre>'
    );
    
    // Convert inline code
    formattedContent = formattedContent.replace(
      /`([^`]+)`/g, 
      '<code class="inline-code">$1</code>'
    );
    
    // Convert bold text
    formattedContent = formattedContent.replace(
      /\*\*([^*]+)\*\*/g, 
      '<strong>$1</strong>'
    );
    
    // Convert italic text
    formattedContent = formattedContent.replace(
      /\*([^*]+)\*/g, 
      '<em>$1</em>'
    );
    
    // Convert links
    formattedContent = formattedContent.replace(
      /\[([^\]]+)\]\(([^)]+)\)/g, 
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );
    
    // Convert list items
    formattedContent = formattedContent.replace(
      /^-\s(.+)$/gm,
      '<li>$1</li>'
    );
    
    // Convert line breaks to <br> tags
    formattedContent = formattedContent.replace(/\n/g, '<br>');
    
    return { __html: formattedContent };
  };